<template>
    <div>
        <div class="releasenotes">
        <h3 class="purple-text">Privacy Policy  </h3>
        <p>Effective Date: November 19, 2025

27pub.com (“we,” “our,” or “us”) values your privacy. This Privacy Policy explains how we collect, use, and protect information when you use our website.

1. Information We Collect
   - Information you voluntarily provide (such as when you enter data into forms).
   - Technical information automatically collected (such as IP address, browser type, and usage data).

2. Use of Information
   - We use information to operate, maintain, and improve the website.
   - Any information entered into the website may be used in an aggregated and anonymized form for analytical, research, or business purposes. This means individual users cannot be identified from the data.

3. Sharing of Information
   - We do not sell or rent your personal information.
   - Aggregated and anonymized data may be shared with partners, advertisers, or service providers for legitimate purposes.

4. Data Retention
   - We retain information only as long as necessary to fulfill the purposes outlined in this Privacy Policy or as required by law.

5. Security
   - We implement reasonable safeguards to protect information from unauthorized access, disclosure, or misuse.
   - However, no method of transmission over the Internet or electronic storage is completely secure.

6. Age Restriction
   - This website is intended for individuals 18 years of age or older. We do not knowingly collect information from minors.

7. Your Rights
   - Depending on your jurisdiction, you may have rights to access, correct, or delete your personal information.
   - To exercise these rights, please contact us at [Insert Contact Email].

8. Changes to This Policy
   - We may update this Privacy Policy from time to time. Updates will be posted on this page with a revised effective date.

By using 27pub.com, you consent to the collection and use of information as described in this Privacy Policy.
</p>
    </div>
</div>
</template>

<script setup>

</script>

<style>

.feedbacklist {
    text-emphasis: none;
}
.version {
    width: 10%;
}

.updates {
    width: 80%;
}

</style>